import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { Col, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import AboutEmployeeCard from 'views/hrms/employee/employee-detail/AboutEmployeeCard';
import EmployeeAddressCard from 'views/hrms/employee/employee-detail/EmployeeAddressCard';
import EmployeeDetailsOffcanvas from 'views/hrms/employee/employee-detail/EmployeeDetailsOffcanvas';
import EmployeeDetailsTab from 'views/hrms/employee/employee-detail/EmployeeDetailsTab';
import EmployeeProfileCard from 'views/hrms/employee/employee-detail/EmployeeProfileCard';
import Button from 'components/base/Button';
import ToolTipButton from 'components/common/TooltipButton';
import { Icon } from '@iconify/react';
import {
  useLoaderData,
  useNavigate,
  useParams,
  useRevalidator
} from 'react-router-dom';
import EmployeeListViewOffcanvas from 'views/hrms/employee/employee-detail/EmployeeListViewOffcanvas';
import apiEndpoints from 'constants/apiEndpoints';
import useFetchData from 'hooks/custom/useFetchData';
import DropdownActions from 'components/custom/ui/DropdownActions';
import IncompleteDetailAlert from 'views/hrms/employee/employee-detail/IncompleteDetailAlert';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import { hrmsPaths } from 'constants/pagePath';
import PageLoader from 'components/custom/animate-component/PageLoader';
import { Modal } from 'react-bootstrap';
import { useAuth } from 'hooks/auth/useAuth';
import useHandleDelete from 'hooks/custom/useHandleDelete';

const page_breadcump = [
  {
    label: 'Home',
    url: '/'
  },
  {
    label: 'Employees',
    url: hrmsPaths.employee.list
  },
  {
    label: 'Employee detail',
    active: true
  }
];

const EmployeeDetail = () => {
  const employeeData = useLoaderData();
  console.log(
    '🚀 ~ EmployeeDetail ~ employeeData:',
    employeeData?.personal_information?.first_name
  );
  const [loading, loadingMessage, handleLoading] = useManagePageLoading();
  const [openOffcanvas, setOpenOffcanvas] = useState(false);
  const [openEmployeeOffcanvas, setOpenEmployeeOffcanvas] = useState(false);
  const [currentEmployeeId, setCurrentEmployeeId] = useState(null);
  const [allEmployeeList] = useFetchData(apiEndpoints.employee.getAll);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [newUnblockPin, setNewUnblockPin] = useState('');
  const employeeDelete = useHandleDelete();
  const { revalidate } = useRevalidator();
  const { abilities } = useAuth();
  const navigate = useNavigate();
  const handleRefresh = () => {
    revalidate();
  };

  const { showAlert } = useAlert();

  const handleRedirectToList = () => {
    navigate(hrmsPaths.employee.list);
  };

  const handleDeleteEmployee = async () => {
    const employee = employeeData?.personal_information;
    employeeDelete({
      label: 'Employee',
      name: employee.first_name,
      url: apiEndpoints.employee.delete(employee.employee_id),
      handleLoading,
      handleRefresh: handleRedirectToList,
      payLoad: {
        // employee_status: 'Deleted',
        employee_id: employee.employee_id
      }
    });
  };

  const params = useParams();
  useEffect(() => {
    if (params?.id) {
      setCurrentEmployeeId(params.id);
    }
  }, [params]);

  const handleAllowCasualBreak = async value => {
    handleLoading(true, 'Allowing casual break');
    const request = await postData(
      {
        user_id: value,
        user_type: 'Employee'
      },
      apiEndpoints.punch.allowCasualBreak
    );
    if (request.status) {
      showAlert({
        variant: 'success',
        message: `Casual break has been allowed.`
      });
      handleLoading(false);
      handleRefresh();
    } else {
      showAlert({
        variant: 'danger',
        message: `Casual break already allowed.`
      });
      handleLoading(false);
    }
  };
  const handleAllowPunch = async value => {
    handleLoading(true, 'Resetting punch');

    const request = await postData(
      {
        user_id: value,
        user_type: 'Employee'
      },
      apiEndpoints.punch.reset
    );
    if (request.status) {
      showAlert({
        variant: 'success',
        message: `Punch has been successfully reset.`
      });
      handleRefresh();
      handleLoading(false);
    } else {
      showAlert({
        variant: 'danger',
        message: `Employee already punched in.`
      });
      handleLoading(false);
    }
  };

  const handleUnblockEmployee = async value => {
    console.log('🚀 ~ EmployeeDetail ~ values:', value);
    const endpoint = apiEndpoints.employee.unBlockEmployee;

    const request = await postData(
      {
        employee_id: value
      },
      endpoint
    );

    if (request.status) {
      // setLoading(false);
      setShowSuccessModal(true);
      setNewUnblockPin(request.data.new_pin);
      // showAlert({
      //   variant: 'info',
      //   message: `Successfully Un-Bock The Employee .`
      // });
    } else {
      // setLoading(false);
      showAlert({
        variant: 'danger',
        message: `Failed to Un-Block the Employee. Please try again later.`
      });
    }
  };
  const actions = [
    {
      label: 'Allow punch in',
      icon: 'fluent:arrow-reset-32-filled',
      disabled: !abilities.can('edit', 'Employee'),
      action: () => handleAllowPunch(currentEmployeeId)
    },
    {
      label: 'Allow Casual Break',
      icon: 'fa6-regular:clock',
      disabled: !abilities.can('edit', 'Employee'),
      iconClassName: 'me-1',
      action: () => handleAllowCasualBreak(currentEmployeeId)
    },
    {
      label: 'Un-Block the Employee',
      icon: 'fluent:arrow-reset-32-filled',
      disabled: !abilities.can('edit', 'Employee'),
      iconClassName: 'me-1',
      action: () => handleUnblockEmployee(currentEmployeeId)
    },
    {
      label: 'divider'
    },
    {
      label: 'Delete Employee',
      icon: 'heroicons-outline:trash',
      className: 'text-danger',
      action: handleDeleteEmployee,
      disabled: !abilities.can('delete', 'Employee')
    }
  ];

  return (
    <>
      <div>
        <PageBreadcrumb items={page_breadcump} />
        <div className="pb-9">
          <Row className="align-items-center justify-content-between g-3 mb-3">
            <Col xs={12} md="auto">
              <h2 className="mb-0">Employee details</h2>
            </Col>

            <Col xs={12} md="auto">
              <div className="d-flex gap-2">
                <div className="flex-1 d-md-none">
                  <Button
                    variant="phoenix-secondary"
                    className="px-3 text-700"
                    onClick={() => setOpenOffcanvas(true)}
                  >
                    <FontAwesomeIcon icon={faBars} />
                  </Button>
                </div>
                <DropdownActions actions={actions} />
                <ToolTipButton
                  label="Show Employee list"
                  variant="phoenix-secondary"
                  className="px-3 text-700"
                  onClick={() => setOpenEmployeeOffcanvas(true)}
                >
                  <Icon
                    icon="fluent:apps-list-detail-24-regular"
                    fontSize="20px"
                  />
                </ToolTipButton>
              </div>
            </Col>
          </Row>
          {employeeData.percentage < 100 && (
            <Row className="w-85 mx-auto">
              <IncompleteDetailAlert
                percentage={employeeData.percentage}
                employee_id={employeeData.personal_information?.employee_id}
              />
            </Row>
          )}

          <Row className="g-0 g-md-4 g-xl-6">
            <Col md={5} xl={4} className="d-none d-md-block">
              <div className="">
                <div className="lead-details-offcanvas bg-soft scrollbar">
                  <div className="d-flex justify-content-between align-items-center mb-2 d-md-none">
                    <h3 className="mb-0">Employee Details</h3>
                  </div>
                  <EmployeeProfileCard
                    className="mb-3"
                    data={employeeData || {}}
                  />
                  <AboutEmployeeCard
                    className="mb-3"
                    data={employeeData || {}}
                  />
                  <EmployeeAddressCard data={employeeData || {}} />
                </div>
              </div>
            </Col>
            <Col md={7} xl={8}>
              <div className="lead-details-container">
                <EmployeeDetailsTab data={employeeData || {}} />
              </div>
            </Col>
          </Row>
        </div>
        <EmployeeDetailsOffcanvas
          data={employeeData || {}}
          open={openOffcanvas}
          setOpen={setOpenOffcanvas}
        />
        <EmployeeListViewOffcanvas
          open={openEmployeeOffcanvas}
          setOpen={setOpenEmployeeOffcanvas}
          employeeId={currentEmployeeId}
          data={allEmployeeList || []}
        />
        <PageLoader loading={loading} loadingMessage={loadingMessage} />
      </div>
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> Employee New Pin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          The new PIN for {employeeData?.personal_information?.first_name} is :{' '}
          <span className="fw-bold"> {newUnblockPin}</span>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowSuccessModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EmployeeDetail;
